import { Component } from "react"
import PropTypes from "prop-types"

import { createOrderByFilterGroup, genericFilterGroup } from "shared/search/containers/FilterGroup/FilterGroups"

import {
    createListFilter,
    createNotInListFilter,
    ManuallyChangedInListFilter,
    LegislativeSessionFilter,
    PriorityFilter,
    PriorityLastUserFilter,
    StanceFilter,
    StanceLastUserFilter,
    ReviewedByMeFilter,
    ReviewedByOrgFilter,
    ReviewedByTeamFilter,
    ReviewedByUserFilter,
    NotReviewedByUserFilter,
} from "shared/search/containers/Filter/Filters"

import { inIssueFilter, notInIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import {
    AmendmentBillFilter,
    AmendmentOfferedDateEndFilter,
    AmendmentOfferedDateStartFilter,
    AmendmentSponsorFilter,
    AmendmentCosponsorFilter,
    AmendmentSponsorOrCosponsorFilter,
    AmendmentStatusDateFilter,
    AmendmentStatusFilter,
    AmendmentTypeFilter,
    // Committee profile
    AmendmentCommitteProfileFilter,
} from "shared/search/containers/Filter/AmendmentFilters"

const defaultProps = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}

export class AmendmentBillFilterGroup extends Component {
    static defaultProps = {
        filters: [AmendmentBillFilter],
        uniqueFilterGroupId: "amendmentBillFilterGroup",
        displayLabel: "Bill",
        helpText: "Filter for amendments that are related to a particular bill.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class AmendmentSessionFilterGroup extends Component {
    static defaultProps = {
        filters: [LegislativeSessionFilter],
        uniqueFilterGroupId: "amendmentSessionFilterGroup",
        displayLabel: "Date",
        helpText: "Filter amendments by their relevant bill's session.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class AmendmentTypeFilterGroup extends Component {
    static defaultProps = {
        filters: [AmendmentTypeFilter],
        uniqueFilterGroupId: "amendmentTypeFilterGroup",
        displayLabel: "Chamber",
        helpText: "Filter amendments by their chamber of origin.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class AmendmentSponsorFilterGroup extends Component {
    static defaultProps = {
        filters: [AmendmentSponsorFilter, AmendmentCosponsorFilter, AmendmentSponsorOrCosponsorFilter],
        uniqueFilterGroupId: "amendmentSponsorFilterGroup",
        displayLabel: "Sponsors",
        helpText: "Filter amendments by the legislator that proposed them.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class AmendmentStatusFilterGroup extends Component {
    static defaultProps = {
        filters: [
            AmendmentStatusFilter,
            AmendmentStatusDateFilter,
            AmendmentOfferedDateStartFilter,
            AmendmentOfferedDateEndFilter,
        ],
        uniqueFilterGroupId: "amendmentStatusFilterGroup",
        displayLabel: "Status",
        helpText: "Filter amendments by their current status and by when that " + "status last changed.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class AmendmentListFilterGroup extends Component {
    static defaultProps = {
        filters: [
            createListFilter(DjangIO.app.models.QuorumDataType.amendment.value),
            createNotInListFilter(DjangIO.app.models.QuorumDataType.amendment.value),
            ManuallyChangedInListFilter,
        ],
        uniqueFilterGroupId: "amendmentListFilterGroup",
        displayLabel: "Lists",
        helpText: "Filter amendments by the lists they have been added",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class AmendmentProjectFilterGroup extends Component {
    static defaultProps = {
        filters: [inIssueFilter, notInIssueFilter],
        uniqueFilterGroupId: "amendmentProjectFilterGroup",
        displayLabel: "Issues",
        helpText: "Filter amendments by tagged Issues.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const AmendmentCommitteeProfileFilterGroup = (props) => genericFilterGroup(props)
AmendmentCommitteeProfileFilterGroup.propTypes = defaultProps
AmendmentCommitteeProfileFilterGroup.defaultProps = {
    filters: [AmendmentCommitteProfileFilter],
    uniqueFilterGroupId: "amendmentCommitteeProfileFilterGroup",
    noHeader: true,
    alwaysOpen: true,
}

export class AmendmentStanceFilterGroup extends Component {
    static defaultProps = {
        filters: [StanceFilter, StanceLastUserFilter],
        uniqueFilterGroupId: "amendmentStanceFilterGroup",
        displayLabel: "Stance",
        helpText: "Filter amendments by your organization's stance.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export class AmendmentPriorityFilterGroup extends Component {
    static defaultProps = {
        filters: [PriorityFilter, PriorityLastUserFilter],
        uniqueFilterGroupId: "amendmentPriorityFilterGroup",
        displayLabel: "Priority",
        helpText: "Filter amendments by your organization's indicated priority.",
    }

    render() {
        return genericFilterGroup(this.props)
    }
}

export const AmendmentOrderByFilterGroup = createOrderByFilterGroup({
    quorumDataType: DjangIO.app.models.QuorumDataType.amendment.value,
})

export const AmendmentReviewFilterGroup = (props) => genericFilterGroup(props)
AmendmentReviewFilterGroup.propTypes = defaultProps
AmendmentReviewFilterGroup.defaultProps = {
    filters: [
        ReviewedByMeFilter,
        ReviewedByOrgFilter,
        ReviewedByUserFilter,
        ReviewedByTeamFilter,
        NotReviewedByUserFilter,
    ],
    uniqueFilterGroupId: "amendmentReviewFilterGroup",
    displayLabel: "Review Status",
    helpText: "Filter results by review status of amendment",
}
